// Professional Color Palette
export const colors = {
  // Primary Colors
  primary: {
    main: '#5A6C7D',
    light: '#7A8B9C',
    dark: '#4A5B6C',
    darker: '#3A4B5C'
  },
  
  // Secondary Colors
  secondary: {
    main: '#27AE60',
    light: '#58D68D',
    dark: '#229954',
    darker: '#1E8449'
  },
  
  // Neutral Colors
  neutral: {
    white: '#FFFFFF',
    lightGray: '#F8F9FA',
    gray: '#E1E8ED',
    mediumGray: '#95A5A6',
    darkGray: '#7F8C8D',
    charcoal: '#2C3E50'
  },
  
  // Background Colors
  background: {
    main: '#F8F9FA',
    secondary: '#FFFFFF',
    accent: '#F5F7FA'
  },
  
  // Text Colors
  text: {
    primary: '#2C3E50',
    secondary: '#7F8C8D',
    light: '#95A5A6'
  },
  
  // Border Colors
  border: {
    light: '#E1E8ED',
    medium: '#95A5A6',
    accent: '#5A6C7D'
  },
  
  // Status Colors
  status: {
    success: '#27AE60',
    warning: '#F39C12',
    error: '#E74C3C',
    info: '#5A6C7D'
  },
  
  // Gradient Colors
  gradients: {
    primary: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
    secondary: 'linear-gradient(135deg, #27AE60 0%, #2ECC71 100%)',
    accent: 'linear-gradient(135deg, #7A8B9C 0%, #6A7B8C 100%)'
  }
};

export default colors;
